import * as React from "react";
import PropTypes from "prop-types";
import { styled, useTheme } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box, FormControl, useMediaQuery } from "@mui/material";
import { Typography } from "../../Styles/GlobalStyles/Variables";
import { CustomGreenButton, GreyOutlinedButton } from "../Button/CustomButton";


const BootstrapDialog = styled(Dialog)(({ theme, width, fullScreen }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(3),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(2),
    },
    "& > .MuiBackdrop-root": {
        backdropFilter: "blur(4px)",
    },
    "& .MuiDialog-paper": {
        borderRadius: fullScreen ? "0px" : "12px",
        ...(width &&
            !fullScreen && {
            width: width,
        }),
        boxShadow: 'rgba(62, 80, 96, 0.2) 0px 4px 20px'
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2, fontWeight: 700 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 10,
                        color: (theme) => theme.palette.grey[500],
                        backgroundColor: (theme) => theme.palette?.closeIcon?.main,
                        borderRadius: "5px",
                        "&:hover": {
                            color: (theme) => theme.palette.error.main,
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function Modal({
    open,
    handleClose,
    content,
    maxWidth,
    width,
}) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    return (
        <div>
            <BootstrapDialog
                aria-labelledby="customized-dialog-title"
                open={open}
                fullScreen={fullScreen}
                fullWidth={true}
                maxWidth={maxWidth ?? "sm"}
                width={width ?? ""}
                PaperProps={{
                    elevation: 0,
                }}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    {content.title ?? ""}
                </BootstrapDialogTitle>
                <DialogContent dividers={content?.footer && true}>
                    <Box>{content.content ?? ""}</Box>
                </DialogContent>
                {content?.footer && (
                    <DialogActions>
                        <FormControl>
                            <GreyOutlinedButton
                                sx={{ fontFamily: Typography.secondaryFont }}
                                autoFocus
                                onClick={handleClose}
                            >
                                Cancel
                            </GreyOutlinedButton>
                        </FormControl>
                        <FormControl>
                            {content?.footer?.action &&
                                <CustomGreenButton
                                    loading={content?.button?.loading ?? false}
                                    onClick={content?.onClick}
                                >
                                    {content?.footer?.action}
                                </CustomGreenButton>}
                        </FormControl>
                    </DialogActions>
                )}
            </BootstrapDialog>
        </div>
    );
}
